<template>
  <div>
    <v-stepper v-model="step" alt-labels class="elevation-0" non-linear>
      <v-stepper-header class="elevation-0">
        <v-stepper-step
            step="1"
            editable
            :complete="isComplete('register')"
            :rules="[() => isValid('register')]"
        >register
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
            step="2"
            editable
            :complete="isComplete('contestants')"
            :rules="[() => isValid('contestants')]"
        >
          contestants
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
            step="3"
            editable
            :complete="isComplete('timing')"
            :rules="[() => isValid('timing')]"
        >timing
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
            step="4"
            editable
            :complete="isComplete('winner')"
            :rules="[() => isValid('winner')]"
        >winner
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
            step="5"
            editable
            :complete="isComplete('share')"
            :rules="[() => isValid('share')]"
        >share
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <Register ref="register" v-model="validations.register" @setState="setState" :edit="edit"/>
        </v-stepper-content>

        <v-stepper-content step="2">
          <Contestants ref="contestants" v-model="validations.contestants" @setState="setState"/>
        </v-stepper-content>

        <v-stepper-content step="3">
          <Timing ref="timing" v-model="validations.timing" @setState="setState"/>
        </v-stepper-content>

        <v-stepper-content step="4">
          <winner ref="winner" v-model="validations.winner" @setState="setState"/>
        </v-stepper-content>

        <v-stepper-content step="5">
          <share ref="share" v-model="validations.share"/>
          <v-alert :value="!!isError" outline color="error" icon="warning" style="border-radius: 0.5rem;">
            {{isError}}
          </v-alert>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round flat color="warning" @click="preview"
                   :disabled="!validations.share"
            >preview
            </v-btn>
            <v-btn round color="warning" @click="submit" v-if="!edit"
                   :disabled="!validations.share" :loading="isLoading">publish
            </v-btn>
          </v-card-actions>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog
        v-model="playDialog"
        scrollable :max-width="`${instaplay.InstaplayType === 'bracket' ? 1000 : device.width/1.2}px`"
    >
      <v-card>
        <v-card-title class=" py-2" primary-title>
          <v-layout align-center justify-space-between row>
          <span class="subheading font-weight-bold">
            Preview
          </span>
          <v-flex>
          <v-select
              v-model="device"
              :items="devices"
              class="py-0 px-2"
          >
          </v-select>
          </v-flex>
          <v-btn icon @click="playDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          </v-layout>
        </v-card-title>

        <v-card-text class="pt-0" :style="`height: ${device.height/1.2}px`">
          <v-slide-x-transition leave-absolute>
            <instaplay-preview ref="playInstaplay"
                               :instaplay="instaplay"
                               :key="instaplay.InstaplayId"
                               class="transition-ease-in-out"
                               preview
            ></instaplay-preview>
          </v-slide-x-transition>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
        v-model="dialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Fill out the &thinsp;
          <span class="red--text"><v-icon color="red">warning</v-icon>&nbsp;marked</span>
          forms please.
        </v-card-title>
        <!--        <v-card-text>-->
        <!--        </v-card-text>-->
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="green darken-1"
              flat="flat"
              @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import Register from "@/components/Register";
    import Contestants from "@/components/Contestants";
    import Timing from "@/components/Timing";
    import Winner from "@/components/Winner";
    import Share from "@/components/Share";
    import {mapGetters} from "vuex"
    import {mapMutations} from "vuex"
    import InstaplayPreview from "@/components/InstaplayPreview";

    export default {
        name: "InstaplayForm",
        components: {InstaplayPreview, Register, Contestants, Timing, Winner, Share},
        props: {
            edit: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                device: { width: 375, height: 667 },
                devices: [
                    { text: 'iphone 5/SE', value: { width: 320, height: 568 } },
                    { text: 'iphone 6/7/8', value: { width: 375, height: 667 } },
                    { text: 'iphone 6/7/8 Plus', value: { width: 414, height: 736 } },
                    { text: 'iphone X', value: { width: 375, height: 812 } }
                ],
                dialog: false,
                validations: {
                    register: false,
                    contestants: false,
                    timing: false,
                    winner: false,
                    share: false,
                },
                steps: ['', 'register', 'contestants', 'timing', 'winner', 'share'],
                instaplay: {},
                playDialog: false
            }
        },
        computed: {
            step: {
                get() {
                    return this.$store.state.instaplayForm.step
                },
                set(newValue) {
                    this.setState(newValue)
                }
            },
            ...mapGetters('instaplayForm', ['isValid', 'isComplete', 'areAllValid', 'isLoading', 'isError'])
        },
        methods: {
            ...mapMutations('notification', ['showSnackbar']),
            submit: function () {
                this.updateState('all')
                if (!this.areAllValid) {
                    this.dialog = true
                    return
                }
                this.$store.dispatch('instaplayForm/createInstaplay').then(success => {
                    if (success === 1) {
                        this.reset()
                        this.showSnackbar({text: 'Instaplay created.', type: 'success'})
                        this.$router.push({name: 'home'})
                    }
                })

            },
            preview() {
                this.$store.dispatch('instaplayForm/createInstaplay', true)
                    .then(preview => {
                        this.instaplay = preview
                        this.playDialog = true
                    })
            },
            async reset() {
                if (this.$refs.register)
                    this.$refs.register.reset()
                await this.$store.dispatch('resetInstaplayFormState')
            },
            updateState: function (step, newStep = 1) {
                if (step === 'all') {
                    for (let i = 1; i < this.steps.length; i++)
                        this.$store.commit('instaplayForm/setValidation', {
                            form: this.steps[i],
                            isValid: this.validations[this.steps[i]]
                        })

                } else {
                    step = parseInt(step)
                    if (newStep === step)
                        return
                    this.$store.commit('instaplayForm/setValidation', {
                        form: this.steps[step],
                        isValid: this.validations[this.steps[step]]
                    })
                }
            },
            setState: function (newState) {
                this.updateState(this.step, newState)
                this.$store.commit('instaplayForm/setState', newState)
            }
        },
    }
</script>

<style scoped>

</style>
